/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Seat_Type_Schedule_Cancelled_DescInputs */



/**
* | output |
* | --- |
* | "A scheduled seat type change was cancelled before the renewal. The member keeps their current type." |
*
* @param {Audit_Details_Member_Seat_Type_Schedule_Cancelled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_seat_type_schedule_cancelled_desc = /** @type {((inputs?: Audit_Details_Member_Seat_Type_Schedule_Cancelled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Seat_Type_Schedule_Cancelled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine geplante Sitztypänderung wurde vor der Verlängerung abgebrochen. Das Mitglied behält den aktuellen Typ.")
	return /** @type {LocalizedString} */ ("A scheduled seat type change was cancelled before the renewal. The member keeps their current type.")
});